module.exports = __webpack_public_path__ + "static/media/vf_wpants_core.113a868d.svg";